
(function () {
  'use strict';

  if (window.__wcEdgeSwipeBack) return;
  window.__wcEdgeSwipeBack = true;

  var EDGE_ZONE_PX    = 200;    // touchstart must be within this many px of the left edge
  var MIN_DISTANCE_PX = 45;     // distance threshold (slow drag)
  var FLICK_VELOCITY  = 0.4;    // px/ms — quick flick commits below MIN_DISTANCE_PX
  var FLICK_MIN_PX    = 25;     // minimum travel even for a flick
  var MAX_VERTICAL_PX = 60;
  var MAX_DURATION_MS = 1500;
  var COMMIT_MS       = 120;    // shortened from 220ms to minimize the
                                // dark/white interstitial between slide-
                                // end and the browser's navigation
  var SNAP_BACK_MS    = 200;

  var startX = 0;
  var startY = 0;
  var startT = 0;
  var tracking = false;
  var mode = 'idle';            // 'idle' | 'page' | 'drawer'
  var bodyEl = null;
  var htmlEl = null;
  var savedHtmlBg = '';
  var drawerEl = null;          // element being painted in 'drawer' mode (the inner panel)
  var drawerCloseFn = null;     // function that closes the open drawer

  // ───── helpers ─────
  // The visible drawer panel is .drawer__inner (slides via CSS
  // transform: translateX(0|100%) with a 0.2s transition). Painting on
  // <cart-drawer> directly causes a snap-back when our inline transform
  // is cleared because cart-drawer itself isn't part of the close
  // transition. So we paint on .drawer__inner and let its existing CSS
  // transition carry it from the dragged position to the closed state.
  function findOpenCartContext() {
    var cd = document.querySelector('cart-drawer.active');
    if (!cd) return null;
    var inner = cd.querySelector('.drawer__inner');
    if (!inner) return null;
    return {
      paintEl: inner,
      closeFn: function () { if (typeof cd.close === 'function') cd.close(); }
    };
  }
  function findOpenMenuContext() {
    var summary = document.querySelector('details[open] > summary[aria-controls^="menu-drawer"]');
    if (!summary) return null;
    var details = summary.parentElement;
    var panel = details ? details.querySelector('.menu-drawer__inner-container, .menu-drawer') : null;
    if (!panel) return null;
    return {
      paintEl: panel,
      closeFn: function () { summary.click(); }
    };
  }

  // PDP image carousel: if the user has swiped past the first product
  // image, a left-edge swipe should be eaten by the carousel (going
  // back to image 1) rather than navigating off the page entirely.
  // Reads slider-component.currentPage; falls back to scrollLeft on
  // the inner scroll container in case currentPage hasn't been
  // computed yet (e.g. before initPages runs).
  function isPdpCarouselPastFirstImage() {
    var slider = document.querySelector('slider-component.wc-pdp-main-slider');
    if (!slider) return false;
    if (typeof slider.currentPage === 'number' && slider.currentPage > 1) return true;
    var scroller = slider.slider || slider.querySelector('[id^="Slider-"]');
    if (scroller && scroller.scrollLeft > 10) return true;
    return false;
  }

  // ───── page-slide painters ─────
  // Sentinel — set when WE applied inline body styles. The pageshow
  // listener at the bottom of this file uses it to avoid wiping styles
  // applied by other scripts (none today, but keeps this behavior
  // narrow + future-safe).
  var ourBodyStyles = false;

  function pageBeginPaint() {
    bodyEl = document.body;
    htmlEl = document.documentElement;
    savedHtmlBg = htmlEl.style.backgroundColor || '';
    // Don't tint the html background. Earlier we set it dark so the
    // exposed area "behind" the sliding body would read as depth, but
    // it created a dark→white double-flash sequence on swipe-back: dark
    // void at the end of the slide-off, then the browser's white nav
    // interstitial. Leaving html at its default means the slide reveals
    // a continuous white that blends with the next page's first paint.
    bodyEl.style.transition = 'none';
    bodyEl.style.willChange = 'transform';
    bodyEl.style.transform = 'translateX(0px)';
    ourBodyStyles = true;
  }
  function pagePaint(dx) {
    if (bodyEl) bodyEl.style.transform = 'translateX(' + dx + 'px)';
  }
  function pageCommitOff() {
    if (!bodyEl) return;
    bodyEl.style.transition = 'transform ' + COMMIT_MS + 'ms cubic-bezier(.2,.8,.4,1)';
    bodyEl.style.transform = 'translateX(100vw)';
    setTimeout(function () {
      if (window.history && window.history.length > 1) {
        window.history.back();
      } else {
        pageSnapBack();
      }
    }, COMMIT_MS);
  }
  function pageSnapBack() {
    if (!bodyEl) return;
    bodyEl.style.transition = 'transform ' + SNAP_BACK_MS + 'ms cubic-bezier(.2,.8,.4,1)';
    bodyEl.style.transform = 'translateX(0px)';
    var b = bodyEl, h = htmlEl, bg = savedHtmlBg;
    setTimeout(function () {
      b.style.transform = '';
      b.style.transition = '';
      b.style.willChange = '';
      h.style.backgroundColor = bg;
      ourBodyStyles = false;
    }, SNAP_BACK_MS + 10);
    bodyEl = null;
    htmlEl = null;
  }

  // ───── drawer-slide painters ─────
  function drawerBeginPaint(ctx) {
    drawerEl = ctx.paintEl;
    drawerCloseFn = ctx.closeFn;
    drawerEl.style.transition = 'none';
    drawerEl.style.willChange = 'transform';
    drawerEl.style.transform = 'translateX(0px)';
  }
  function drawerPaint(dx) {
    if (drawerEl) drawerEl.style.transform = 'translateX(' + dx + 'px)';
  }
  function drawerCommitClose() {
    if (!drawerEl) return;
    var el = drawerEl;
    var fn = drawerCloseFn;
    // Clear inline transform/transition synchronously and trigger close
    // in the SAME tick. With paintEl = .drawer__inner, the existing CSS
    // rule (.drawer__inner { transform: translateX(100%); transition:
    // transform 0.2s ease; }) takes over. Browser sees a single
    // transition from "previous paint" (dragged position) to closed
    // state (translateX(100%)) with no intermediate snap-back.
    el.style.transition = '';
    el.style.transform  = '';
    el.style.willChange = '';
    if (typeof fn === 'function') fn();
    drawerEl = null;
    drawerCloseFn = null;
  }
  function drawerSnapBack() {
    if (!drawerEl) return;
    var el = drawerEl;
    el.style.transition = 'transform ' + SNAP_BACK_MS + 'ms cubic-bezier(.2,.8,.4,1)';
    el.style.transform = 'translateX(0px)';
    setTimeout(function () {
      el.style.transform = '';
      el.style.transition = '';
      el.style.willChange = '';
    }, SNAP_BACK_MS + 10);
    drawerEl = null;
    drawerCloseFn = null;
  }

  // ───── unified handlers ─────
  function onStart(e) {
    if (!e.touches || e.touches.length !== 1) return;
    var t = e.touches[0];
    if (t.clientX > EDGE_ZONE_PX) return;

    // Modal/popup guard: if a full-screen modal is open (Fit Assistant,
    // size chart, etc.), let the modal handle its own touch interactions.
    // Engaging the page-slide gesture here applies a body transform that
    // can cancel input taps inside the modal on iOS Safari.
    // body.wc-modal-open is toggled by main-product.liquid when the
    // Fit Assistant opens; future modals should set the same class.
    if (document.body.classList.contains('wc-modal-open')) return;

    // PDP carousel guard: if the user is past image #1, let the
    // carousel keep the swipe so they can swipe back to image #1.
    if (isPdpCarouselPastFirstImage()) return;

    // Dismiss the PDP tier banner on touch start. The banner already
    // has pointer-events:none (so it can't intercept), but its slide-in
    // animation while a swipe-back is in flight is visually distracting
    // — and an accidental product tap is a common reason to swipe back.
    var pdpBanner = document.querySelector('.wc-pdp-tier-banner.is-visible');
    if (pdpBanner) pdpBanner.classList.remove('is-visible');

    var ctx = findOpenCartContext() || findOpenMenuContext();
    if (ctx) {
      mode = 'drawer';
      drawerBeginPaint(ctx);
    } else {
      mode = 'page';
      pageBeginPaint();
    }
    startX = t.clientX;
    startY = t.clientY;
    startT = Date.now();
    tracking = true;
  }

  function onMove(e) {
    if (!tracking) return;
    if (!e.touches || !e.touches[0]) return;
    var t = e.touches[0];
    var dx = Math.max(0, t.clientX - startX);
    var dy = Math.abs(t.clientY - startY);
    if (dy > MAX_VERTICAL_PX) {
      tracking = false;
      if (mode === 'page') pageSnapBack(); else drawerSnapBack();
      mode = 'idle';
      return;
    }
    if (mode === 'page') pagePaint(dx); else drawerPaint(dx);
  }

  function onEnd(e) {
    if (!tracking) return;
    tracking = false;
    var t = e.changedTouches && e.changedTouches[0];
    var dx = t ? (t.clientX - startX) : 0;
    var dy = t ? Math.abs(t.clientY - startY) : 999;
    var dt = Date.now() - startT;
    // Commit if either: traveled past MIN_DISTANCE_PX, or it was a quick
    // flick (FLICK_VELOCITY+ px/ms) with at least FLICK_MIN_PX of travel.
    var velocity = dt > 0 ? dx / dt : 0;
    var passed =
      dx >= MIN_DISTANCE_PX ||
      (velocity >= FLICK_VELOCITY && dx >= FLICK_MIN_PX);
    var success =
      passed &&
      dy <= MAX_VERTICAL_PX &&
      dt <= MAX_DURATION_MS;

    if (mode === 'page') {
      if (success) pageCommitOff(); else pageSnapBack();
    } else if (mode === 'drawer') {
      if (success) drawerCommitClose(); else drawerSnapBack();
    }
    mode = 'idle';
  }

  function onCancel() {
    if (!tracking) return;
    tracking = false;
    if (mode === 'page') pageSnapBack();
    else if (mode === 'drawer') drawerSnapBack();
    mode = 'idle';
  }

  document.addEventListener('touchstart',  onStart,  { passive: true });
  document.addEventListener('touchmove',   onMove,   { passive: true });
  document.addEventListener('touchend',    onEnd,    { passive: true });
  document.addEventListener('touchcancel', onCancel, { passive: true });

  // bfcache safety: if the page is restored with a stale transform we
  // applied, clear it on pageshow so the user doesn't see a blank
  // screen. Gated by ourBodyStyles so we never wipe styles owned by
  // another script.
  window.addEventListener('pageshow', function () {
    if (!ourBodyStyles) return;
    var b = document.body;
    var h = document.documentElement;
    if (b) { b.style.transform = ''; b.style.transition = ''; b.style.willChange = ''; }
    if (h) { h.style.backgroundColor = ''; }
    ourBodyStyles = false;
  });
})();